import { Alert, Box, Button, Typography } from '@mui/material';
import { PropsWithChildren, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth, useAutoSignin } from 'react-oidc-context';

export function RequireAuth({ children }: PropsWithChildren): ReactElement {
  const { isLoading, isAuthenticated, error } = useAutoSignin({
    signinArgs: {
      url_state: window.location.pathname + window.location.search,
    },
  });

  if (error) return <AuthErrorScreen message={error.message} />;

  if (isLoading || !isAuthenticated) return <></>;

  return <>{children}</>;
}

function AuthErrorScreen({ message }: { message: string }): ReactElement {
  const { t } = useTranslation();
  const { signinRedirect } = useAuth();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', p: 3 }}>
      <Alert severity='error' sx={{ maxWidth: 600 }}>
        <Typography variant='h6' gutterBottom>
          {t('auth.error')}
        </Typography>
        <Typography variant='body2' sx={{ mb: 2 }}>
          {message}
        </Typography>
        <Button variant='contained' onClick={() => void signinRedirect()}>
          {t('auth.retry')}
        </Button>
      </Alert>
    </Box>
  );
}
